<script>
    import FormularioAltaTarjeta from '../../components/formularioAltaTarjeta.vue';
export default {
    components:{
        FormularioAltaTarjeta
    }
}
</script>
<template>
    <FormularioAltaTarjeta urlSiguiente="/verificar-correo" />
</template>
